import React, { FC } from 'react';
import styled from 'styled-components';
import { TaskType } from 'api/tasks';
import { ReactComponent as MilestoneIcon } from 'assets/svgs/milestone.svg';
import { ReactComponent as NoStatusIcon } from 'assets/svgs/no-status.svg';

const TaskNoStatus = styled(NoStatusIcon)`
  color: var(--cool-gray-40);
`;

const MilestoneNoStatus = styled(MilestoneIcon)`
  fill: var(--cool-gray-40);
`;

export const StatusDefault: FC<{
  type: TaskType;
}> = ({ type }) =>
  type === 'MILESTONE' ? <MilestoneNoStatus /> : <TaskNoStatus />;
